import { useEffect, useState } from 'react';

const useSwiperProgress = (swiperRef, activeIndex, perGroup) => {
  const [progressPercent, setProgressPercent] = useState(0);
  const [tooltipPercent, setTooltipPercent] = useState(0);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [realSlideCount, setRealSlideCount] = useState(0);

  // 슬라이드 수 자동 계산
  useEffect(() => {
    if (!swiperRef?.current) return;

    const updateRealSlideCount = () => {
      const count = swiperRef.current.slides.filter(
        (slide) => !slide.classList.contains('swiper-slide-duplicate'),
      ).length;
      setRealSlideCount(count);
    };

    updateRealSlideCount();

    // 혹시 Swiper가 재렌더 될 때도 다시 세도록 이벤트 걸어두기
    swiperRef.current.on('slideChange', updateRealSlideCount);
    swiperRef.current.on('slidesLengthChange', updateRealSlideCount);

    // cleanup
    return () => {
      swiperRef.current?.off('slideChange', updateRealSlideCount);
      swiperRef.current?.off('slidesLengthChange', updateRealSlideCount);
    };
  }, [swiperRef]);

  // 퍼센트 계산
  useEffect(() => {
    if (!swiperRef?.current || realSlideCount === 0) return;

    const currentProgress =
      activeIndex + perGroup < realSlideCount
        ? ((activeIndex + perGroup) / realSlideCount) * 100
        : 100;

    setProgressPercent(currentProgress);
  }, [activeIndex, perGroup, realSlideCount]);

  const handleMouseMove = (e) => {
    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    setTooltipPercent(Math.min(Math.max(percent, 0), 100));
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const handleClick = (e) => {
    if (!swiperRef?.current || realSlideCount === 0) return;

    const rail = e.currentTarget;
    const railWidth = rail.offsetWidth;
    const mouseX = e.clientX - rail.getBoundingClientRect().left;
    const percent = (mouseX / railWidth) * 100;

    const targetSlideIndex =
      Math.floor(((percent / 100) * realSlideCount) / perGroup) * perGroup;

    swiperRef.current.slideToLoop(targetSlideIndex);
  };

  return {
    progressPercent,
    tooltipPercent,
    tooltipVisible,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  };
};

export default useSwiperProgress;
